/**
 * @description
 *
 * Here you should declare the state properties and it's initial values
 * @return {object} with state data
 */
const initialState = () => {
    return {
        token: localStorage.getItem('user-token') || '',
        status: '',
        user: JSON.parse(localStorage.getItem('user')),
        hasLoadedOnce: false,
        permissions: JSON.parse(localStorage.getItem('permissions')) || [],
    }
}

export default initialState
